import { render } from "./OrdersView.vue?vue&type=template&id=1c2d7f1a&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"

import "./OrdersView.vue?vue&type=style&index=0&id=1c2d7f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2d7f1a"]])

export default __exports__